import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_TUTORIAL_ACTIVE, SET_TRAINING_TIPS_ACTIVE } from './constants';

const initialState = {
  tutorialIsActive: false,
  trainingTipsIsActive: false,
};

export const tutorialReducer = createReducer(initialState, {
  [SET_TUTORIAL_ACTIVE]: (state, action) => {
    return {
      tutorialIsActive: action.payload,
    };
  },
  [SET_TRAINING_TIPS_ACTIVE]: (state, action) => {
    return {
      trainingTipsIsActive: action.payload,
    };
  },
});
